const burger = document.getElementById('burger');
const menu = document.getElementById('menu');

if(burger && menu) {
    burger.addEventListener('click', () => {
        if(burger.classList.contains('open')) {
            burger.classList.remove('open');
            menu.classList.remove('open');
            burger.innerText = "Open menu";
            document.querySelector("body").style.overflow = "auto";
        } else {
            burger.classList.add('open');
            burger.innerText = "Close menu";
            menu.classList.add('open');
            document.querySelector("body").style.overflow = "hidden";
        }
    });
}

let expandButtons = document.querySelectorAll(".sub-menu");
if(expandButtons) {
    for(let i = 0; i < expandButtons.length; i++) {
        expandButtons[i].addEventListener("click", (event) => {
            event.preventDefault();
            if(expandButtons[i].classList.contains("open")) {
                expandButtons[i].classList.remove("open");
            } else {
                for(let n = 0; n < expandButtons.length; n++) {
                    expandButtons[n].classList.remove("open")
                }
                expandButtons[i].classList.add("open")
            }
        })
    }
}

